import { useFetchData } from 'features/ippica/hooks';
import { selectActiveScommessaForQuoteFinali, selectTiltlesQuoteByGroup } from 'features/ippica/selectors';
import { useTypedSelector } from 'lib/centralStore';
import { IppicaQuoteFinaliResultsContainer } from '../../ippicaQuoteFinaliResultsContainer/IppicaQuoteFinaliResultsContainer';
import styles from './IppicaQuoteFinali.module.scss';
export type IppicaQuoteFinaliProps = {
  title: string;
  hasMarginRight?: boolean;
};

export const IppicaQuoteFinali = ({ title, hasMarginRight }: IppicaQuoteFinaliProps) => {
  const tipoScommessaList = useTypedSelector(selectActiveScommessaForQuoteFinali(false));
  const { data } = useFetchData(tipoScommessaList);
  const titleQuoteList = useTypedSelector(selectTiltlesQuoteByGroup);
  return data ? (
    <div className={`${styles.container} ${hasMarginRight ? styles.withMarginRight : ''}`}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.wrapperQuote}>
        {data.map((quotaFinale) => {
          return (
            <IppicaQuoteFinaliResultsContainer
              key={quotaFinale.meta?.arg?.codiceTipoScommessa}
              title={titleQuoteList?.[quotaFinale.meta?.arg?.codiceTipoScommessa]}
              esitoList={quotaFinale.payload}
            />
          );
        })}
      </div>
    </div>
  ) : null;
};
